module.exports = __webpack_public_path__ + "static/media/logo-novonordiskfonden2.5b055658.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logo-novonordiskfonden2.png
// module id = 1483
// module chunks = 0